import styled, { css } from 'styled-components';
import { mediaQuery } from 'common/theme/media';

const PolicyMobileCss = css`
`;

export const Policy = styled.div`
    ${mediaQuery.lessThan('xltablet')`${PolicyMobileCss}`}
`